var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99851 30C2.23699 30 0 28.4389 0 26.5134V3.48656C0 1.56084 2.23699 -3.61405e-07 4.99851 -3.61405e-07C7.76002 -3.61405e-07 10 1.56114 10 3.48656V26.5134C10 28.4389 7.75968 30 4.99851 30V30Z",
    fill: "#280F2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 30C21.237 30 19 28.4389 19 26.5134V3.48656C19 1.56084 21.237 -3.61405e-07 23.9985 -3.61405e-07C26.76 -3.61405e-07 29 1.56114 29 3.48656L28.9997 26.5134C28.9997 28.4389 26.76 30 23.9985 30H23.9985Z",
    fill: "#280F2C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.0d1ae762a1531acd6cd742c51241e2eb.svg";
export { ForwardRef as ReactComponent };